import { lazy } from 'react';

import type { Routes } from '@/@types/routes';

const authRoute: Routes = [
	{
		key: 'landingPage',
		path: `/`,
		component: lazy(() => import('@/views/public/LandingPage/Index')),
		authority: [],
		meta: {
			layout: 'blank',
			pageContainerType: 'gutterless',
			footer: false,
		},
	},
	{
		key: 'pages',
		path: `/:page`,
		component: lazy(() => import('@/views/public/Pages/Index')),
		authority: [],
		meta: {
			layout: 'blank',
			pageContainerType: 'gutterless',
			footer: false,
		},
	},
];

export default authRoute;
